import axios from 'axios';
import { useCallback, useEffect, useState } from 'react';
import { Container, Row } from 'react-bootstrap';
import api from '../apiClient';
import './BrowseJobs.css';
import BrowseRecentJobs from './BrowseRecentJobs';
import BrowseSearchJobs from './BrowseSearchJobs';
import Footer from './Footer';

const BrowseJobs = () => {
    const BASE_API_URL = process.env.REACT_APP_API_URL;
    const [jobs, setJobs] = useState([]);
    const [companyLogos, setCompanyLogos] = useState({});
    const [search, setSearch] = useState('');
    const [searchPage, setSearchPage] = useState(0);
    const [recentPage, setRecentPage] = useState(0);
    const [searchPageSize, setSearchPageSize] = useState(6);
    const [recentPageSize, setRecentPageSize] = useState(20);
    const [totalPages, setTotalPages] = useState(0);
    const [sortedColumn, setSortedColumn] = useState(null);
    const [sortOrder, setSortOrder] = useState('asc');

    useEffect(() => {
        if (search) {
            fetchJobBySearch();
        } else {
            fetchData();
        }
    }, [searchPage, recentPage, searchPageSize, recentPageSize, search, sortedColumn, sortOrder]);

    const fetchData = useCallback(async () => {
        const params = {
            size: recentPageSize,
            page: recentPage,
            sortBy: sortedColumn,
            sortOrder: sortOrder,
        };
        try {
            const response = await axios.get(`${BASE_API_URL}/paginationJobs`, { params });
            setJobs(response.data.content);
            setTotalPages(response.data.totalPages);
            await fetchImages(response.data.content);
        } catch (error) {
        }
    }, [recentPage, recentPageSize]);

    const fetchImages = async (jobs) => {
        try {
            const logoPromises = jobs.map(job => {
                return fetchCompanyLogo(job.companyName).catch(() => {
                    return "https://static.vecteezy.com/system/resources/previews/013/899/376/original/cityscape-design-corporation-of-buildings-logo-for-real-estate-business-company-vector.jpg";
                });
            });
            const logos = await Promise.all(logoPromises);
            const logosMap = {};
            jobs.forEach((job, index) => {
                logosMap[job.companyName] = logos[index];
            });
            setCompanyLogos(logosMap);
        } catch (error) {
        }
    };

    const fetchCompanyLogo = async (companyName) => {
        try {
            const response = await api.getLogo(companyName);
            return `data:image/jpeg;base64,${btoa(
                new Uint8Array(response.data).reduce((data, byte) => data + String.fromCharCode(byte), '')
            )}`;
        } catch (error) {
            return "https://static.vecteezy.com/system/resources/previews/013/899/376/original/cityscape-design-corporation-of-buildings-logo-for-real-estate-business-company-vector.jpg";
        }
    };

    const fetchJobBySearch = async () => {
        try {
            const response = await api.searchBrowseJobs(search, searchPage, searchPageSize);
            setJobs(response.data.content);
            setTotalPages(response.data.totalPages);
            await fetchImages(response.data.content);
        } catch (error) {
        }
    };

    const handleInputChange = (event) => {
        const inputValue = event.target.value;
        setSearch(inputValue);
        setSearchPage(0);
    };

    const handleSort = (column) => {
        if (sortedColumn === column) {
            setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
        } else {
            setSortedColumn(column);
            setSortOrder('asc');
        }
    };

    const handleSearchPageClick = (data) => {
        const selectedPage = Math.max(0, Math.min(data.selected, totalPages - 1));
        setSearchPage(selectedPage);
    };

    const handleRecentPageClick = (data) => {
        const selectedPage = Math.max(0, Math.min(data.selected, totalPages - 1));
        setRecentPage(selectedPage);
    };

    const handleSearchPageSizeChange = (e) => {
        const size = parseInt(e.target.value);
        setSearchPageSize(size);
        setSearchPage(0);
    };

    const handleRecentPageSizeChange = (e) => {
        const size = parseInt(e.target.value);
        setRecentPageSize(size);
        setRecentPage(0);
    };

    const calculateDaysAgo = (postingDate) => {
        const today = new Date();
        const postDate = new Date(postingDate);
        const timeDiff = today - postDate;
        const daysAgo = Math.floor(timeDiff / (1000 * 3600 * 24));
        if (daysAgo <= 7) {
            return `${daysAgo} days ago`;
        }

        // If the job is older than 7 days, show "> 7 days ago"
        return "> 7 days ago";
    };

    const homeUrl = window.location.hostname === "localhost"
        ? "http://localhost:3001"
        : "https://jobbox.one";

    return (
     <div
  style={{
    overflowX: 'hidden',
    backgroundColor: '#ffffff',
    minHeight: '100vh',
  }}
>
  <div
    style={{
      overflowY: 'auto',
      overflowX: 'hidden',
    }}
  >
    <Container
      fluid
      style={{
        paddingLeft: '20px',
        paddingRight: '20px',
      }}
    >
      <Row>

        {/* Logo */}
        <div
          style={{
            padding: '10px 0 5px 5px',
          }}
        >
          <a href={homeUrl}>
            <img
              src="/jb_logo.png"
              alt="JobBox Logo"
              style={{
                width: '200px',
                height: 'auto',
                maxHeight: '100px',
                cursor: 'pointer',
                objectFit: 'contain',
              }}
            />
          </a>
        </div>

        {/* Heading */}
        <div
          className="text-center"
          style={{
            marginTop: '5px',
            marginBottom: '5px',
          }}
        >
          <h1
            style={{
              fontSize: '32px',
              fontWeight: '600',
              color: '#302b36',
              marginBottom: '8px',
            }}
          >
            Find Your Dream Job & Apply for it
          </h1>

          <p
            style={{
              fontSize: '18px',
              color: '#66616b',
              marginBottom: '20px',
            }}
          >
            Jobs for you to explore
          </p>
        </div>

        {/* Search Bar */}
        <div
          style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            marginBottom: '25px',
          }}
        >
          <div
            className="home-search-bar"
            style={{
              width: '100%',
              maxWidth: '850px',
              backgroundColor: '#f7f7fb',
              border: '1px solid #e5e5ec',
              borderRadius: '10px',
              padding: '8px',
              boxShadow: '0 3px 12px rgba(0, 0, 0, 0.05)',
            }}
          >
            <input
              type="text"
              placeholder="Search by job title / company name / skills / location"
              value={search}
              className="search-input-bar"
              onChange={handleInputChange}
              style={{
                width: '100%',
                height: '46px',
                border: '1px solid #d8d3df',
                borderRadius: '7px',
                padding: '8px 14px',
                backgroundColor: '#ffffff',
                outline: 'none',
                fontSize: '15px',
                color: '#3f3945',
              }}
            />
          </div>
        </div>

        {/* Search Results Section */}
        {jobs.length > 0 && search && (
          <div
            style={{
              width: '100%',
              marginTop: '5px',
            }}
          >
            <BrowseSearchJobs
              jobs={jobs}
              companyLogos={companyLogos}
              page={searchPage}
              size={searchPageSize}
              totalPages={totalPages}
              handlePageSizeChange={handleSearchPageSizeChange}
              handlePageClick={handleSearchPageClick}
              calculateDaysAgo={calculateDaysAgo}
            />
          </div>
        )}

        {/* Newly Posted Jobs Section */}
        {!search && jobs.length > 0 && (
          <div
            style={{
              width: '100%',
              marginTop: '5px',
            }}
          >
            <BrowseRecentJobs
              jobs={jobs}
              companyLogos={companyLogos}
              page={recentPage}
              size={recentPageSize}
              totalPages={totalPages}
              handlePageSizeChange={handleRecentPageSizeChange}
              handlePageClick={handleRecentPageClick}
              calculateDaysAgo={calculateDaysAgo}
            />
          </div>
        )}

        {/* No Jobs */}
        {jobs.length === 0 && search && (
          <div
            className="text-center"
            style={{
              padding: '60px 20px',
              color: '#66616b',
            }}
          >
            <h3
              style={{
                color: '#6c5b7b',
                fontWeight: '600',
                marginBottom: '8px',
              }}
            >
              No jobs found
            </h3>

            <p
              style={{
                fontSize: '14px',
                margin: 0,
              }}
            >
              Try searching with a different job title, company, skill or location.
            </p>
          </div>
        )}

      </Row>
    </Container>
  </div>

  {/* Footer */}
  <div
    style={{
      marginTop: '100px',
    }}
  >
    <Footer />
  </div>
</div>
    );
};

export default BrowseJobs;
